import { Icon, reactive, onCleanup } from 'cdui-js';
import { OPEN_ACCOUNT_IMAGE_MAX_BYTES, UploadImage } from '../../components/Upload';
import { AuthSensitiveImage } from '../../components/AuthSensitiveImage';
import { revokeAuthFileBlobUrl } from '../../../../lib/authFileBlob';
import i18n from '../../../../i18n';

const CloseIcon = (props) => (
  <svg
    class="absolute"
    style={{ bottom: '20px', 'z-index': '99' }}
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
    // onclick={(e) => {
    //   // pState.attachmentList = pState.attachmentList.filter((i) => i.fileUrl !== props.img);
    // }}
    {...props}
  >
    <rect width="46" height="46" rx="23" fill="#1B212D" />
    <path
      d="M13.3672 16.8706H32.6312"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.9696 13.3679H21.0293C20.6809 13.3679 20.3468 13.5063 20.1005 13.7526C19.8542 13.9989 19.7158 14.333 19.7158 14.6814V16.8705H26.2831V14.6814C26.2831 14.333 26.1447 13.9989 25.8984 13.7526C25.6521 13.5063 25.318 13.3679 24.9696 13.3679Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.0288 28.0349V21.4677"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.9697 28.035V21.4678"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.0058 31.4234C28.9814 31.7525 28.8332 32.0601 28.5911 32.2843C28.3491 32.5085 28.031 32.6327 27.7011 32.6318H18.2967C17.9668 32.6327 17.6487 32.5085 17.4066 32.2843C17.1645 32.0601 17.0164 31.7525 16.992 31.4234L15.7749 16.8704H30.2229L29.0058 31.4234Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UploadBankCard = (props) => {
  const state = reactive({
    status: '',
    previewOpen: false,
    previewUrl: '',
    /** 关闭预览后短暂锁，防止点击穿透立刻再次打开 */
    previewCloseLock: false,
    /** 本会话刚上传的本地 blob，优先回显，避免立刻打 /file/content */
    localPreviewUrl: '',
  });

  let closeLockTimer: ReturnType<typeof setTimeout> | null = null;

  /**
   * 释放本会话本地预览 blob。
   */
  const clearLocalPreview = () => {
    if (state.localPreviewUrl) {
      revokeAuthFileBlobUrl(state.localPreviewUrl);
      state.localPreviewUrl = '';
    }
  };

  const lockPreviewReopen = () => {
    state.previewCloseLock = true;
    if (closeLockTimer) clearTimeout(closeLockTimer);
    closeLockTimer = setTimeout(() => {
      state.previewCloseLock = false;
      closeLockTimer = null;
    }, 320);
  };

  onCleanup(() => {
    clearLocalPreview();
    if (closeLockTimer) clearTimeout(closeLockTimer);
  });

  /** 展示用：本地 blob 优先，否则服务端相对路径 */
  const displayPath = () => state.localPreviewUrl || props.img;

  return (
    <div
      class={`flex justify-center align-center flex-column ${props.class}`}
      style={{ height: '188px', position: 'relative' }}
    >
      <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}>
        <svg
          style={{ width: '98%', height: '100%' }}
          // height="188"
          // viewBox="0 0 382 188"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="99%"
            height="187"
            rx="11.5"
            style={{ stroke: 'var(--text-1)' }}
            stroke-linecap="round"
            stroke-dasharray="3 6"
          />
        </svg>
      </div>

      {state.status !== 'loading' && (
        <>
          {displayPath() ? (
            <div
              class="absolute position-t position-b position-l position-r padding-m-XS flex align-center justify-center"
              style={{ 'z-index': 1, cursor: 'pointer', overflow: 'hidden' }}
              onclick={() => {
                if (state.previewCloseLock || !state.previewUrl) return;
                state.previewOpen = true;
              }}
            >
              <AuthSensitiveImage
                class="width-100 height-100"
                style={{
                  'object-fit': 'contain',
                  width: '100%',
                  height: '100%',
                  'max-width': '100%',
                  'max-height': '100%',
                }}
                path={displayPath()}
                previewOpen={state.previewOpen}
                onPreviewClose={() => {
                  state.previewOpen = false;
                  lockPreviewReopen();
                }}
                onUrlReady={(url) => {
                  state.previewUrl = url;
                  if (!url) state.previewOpen = false;
                }}
              />
            </div>
          ) : (
            <div class="flex flex-column align-center">
              <svg
                width="173"
                height="60"
                viewBox="0 0 173 60"
                stroke="none"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="173" height="24.25" rx="5" fill="var(--upload-id-bar)" />
                <rect y="34.125" width="173" height="8" rx="4" fill="var(--upload-id-bar)" />
                <rect y="52" width="83.1426" height="8" rx="4" fill="var(--upload-id-bar)" />
              </svg>

              <div class="color-D flex align-center margin-t-L gap-4px">
                <Icon name="common-plus" class="icon-c-D icon-s-XS"></Icon>
                <div class="font-s-S">{i18n.OpenProgress.Upload.AddBankCard}</div>
              </div>
            </div>
          )}

          {displayPath() && (
            <CloseIcon
              onclick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                state.previewUrl = '';
                state.previewOpen = false;
                clearLocalPreview();
                props.change({
                  type: '',
                  url: '',
                  data: null,
                });
              }}
            />
          )}

          {/* 有可预览图才点图。无图时 input 自己铺满虚线框，不要包 label，否则 iOS 要点两次 */}
          {!displayPath() && (
            <UploadImage
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                'z-index': 2,
              }}
              useFor={'bank_card'}
              isOCR={true}
              maxSize={OPEN_ACCOUNT_IMAGE_MAX_BYTES}
              restrictImageType={true}
              showLoading={false}
              change={(data) => {
                if (data.status === 'success') {
                  state.previewUrl = '';
                  state.previewOpen = false;
                  clearLocalPreview();
                  if (data.localPreviewUrl) {
                    state.localPreviewUrl = data.localPreviewUrl;
                  }
                  props.change({
                    type: '',
                    url: data.filePath,
                    data: data,
                  });
                  state.status = '';
                } else if (data.status === 'error') {
                  state.status = '';
                } else if (data.status === 'loading') {
                  state.status = 'loading';
                } else {
                  state.status = '';
                }
              }}
              busId={props.busId}
              key={'bank_card'}
            />
          )}
        </>
      )}

      {state.status === 'loading' && (
        <svg
          style={{ animation: 'rotate 1s linear infinite' }}
          width="22"
          height="22"
          viewBox="0 0 22 22"
          stroke="none"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#paint0_angular_1280_888_clip_path)" data-figma-skip-parse="true">
            <g transform="matrix(1.02178e-09 0.0109497 -0.0109497 1.02057e-09 10.9497 10.9497)">
              <foreignObject x="-1091.33" y="-1091.33" width="2182.65" height="2182.65">
                <div
                  // @ts-ignore
                  xmlns="http://www.w3.org/1999/xhtml"
                  style="background:conic-gradient(from 90deg,rgba(237, 237, 237, 0) 0deg,rgba(237, 237, 237, 0) 9.59985deg,rgba(115, 115, 115, 1) 360deg);height:100%;width:100%;opacity:1"
                ></div>
              </foreignObject>
            </g>
          </g>
          <path
            d="M10.9492 0C16.9964 0 21.8993 4.90211 21.8994 10.9492C21.8994 16.9964 16.9964 21.8994 10.9492 21.8994C4.90211 21.8993 0 16.9964 0 10.9492C0.00013194 4.90219 4.90219 0.000131943 10.9492 0ZM10.9492 2.17676C6.10401 2.17686 2.17578 6.10497 2.17578 10.9502C2.17593 15.7953 6.1041 19.7226 10.9492 19.7227C15.7944 19.7227 19.7225 15.7954 19.7227 10.9502C19.7227 6.10491 15.7945 2.17676 10.9492 2.17676Z"
            data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.92941176891326904,&#34;g&#34;:0.92941176891326904,&#34;b&#34;:0.92941176891326904,&#34;a&#34;:0.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.92941176891326904,&#34;g&#34;:0.92941176891326904,&#34;b&#34;:0.92941176891326904,&#34;a&#34;:0.0},&#34;position&#34;:0.026666259393095970},{&#34;color&#34;:{&#34;r&#34;:0.45098039507865906,&#34;g&#34;:0.45098039507865906,&#34;b&#34;:0.45098039507865906,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.92941176891326904,&#34;g&#34;:0.92941176891326904,&#34;b&#34;:0.92941176891326904,&#34;a&#34;:0.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.92941176891326904,&#34;g&#34;:0.92941176891326904,&#34;b&#34;:0.92941176891326904,&#34;a&#34;:0.0},&#34;position&#34;:0.026666259393095970},{&#34;color&#34;:{&#34;r&#34;:0.45098039507865906,&#34;g&#34;:0.45098039507865906,&#34;b&#34;:0.45098039507865906,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:2.0435502392501803e-06,&#34;m01&#34;:-21.899415969848633,&#34;m02&#34;:21.89941406250,&#34;m10&#34;:21.899415969848633,&#34;m11&#34;:2.0411489458638243e-06,&#34;m12&#34;:-2.3384584437735612e-06},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
          />
          <ellipse cx="11.0781" cy="20.8112" rx="1.11205" ry="1.08761" fill="#737373" />
          <defs>
            <clipPath id="paint0_angular_1280_888_clip_path">
              <path d="M10.9492 0C16.9964 0 21.8993 4.90211 21.8994 10.9492C21.8994 16.9964 16.9964 21.8994 10.9492 21.8994C4.90211 21.8993 0 16.9964 0 10.9492C0.00013194 4.90219 4.90219 0.000131943 10.9492 0ZM10.9492 2.17676C6.10401 2.17686 2.17578 6.10497 2.17578 10.9502C2.17593 15.7953 6.1041 19.7226 10.9492 19.7227C15.7944 19.7227 19.7225 15.7954 19.7227 10.9502C19.7227 6.10491 15.7945 2.17676 10.9492 2.17676Z" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
};
